import React from 'react';
import { Navigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, perm }) => {
  const { user, loading, can } = useAuth();
  const location = useLocation();
  if (loading) return <div className="spinner" />;
  // Where they were is carried to the login screen, so an expired session in
  // the middle of a day close returns to the day close, not the dashboard.
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (perm && !can(perm)) {
    return (
      <div className="card card-pad" style={{ maxWidth: 460, margin: '3rem auto', textAlign: 'center' }}>
        <h3 style={{ marginTop: 0 }}>No access</h3>
        <p className="muted">You don’t have permission to view this page. Ask an administrator if you need it.</p>
        <Link to="/" className="btn btn-outline btn-sm">Go to Dashboard</Link>
      </div>
    );
  }
  return children;
};

export default ProtectedRoute;
